import {createApp, nextTick} from 'vue'
import axios from 'axios'
import { createPinia, mapActions, mapState } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Sticky from 'vue3-sticky-directive'
import VueClickAway from 'vue3-click-away'
import VueGoogleMaps from 'vue-google-maps-community-fork'
import { defineRule, configure } from 'vee-validate'
import { required, email, numeric } from '@vee-validate/rules'
import VueScrollTo from 'vue-scrollto'
import {vTooltip, Tooltip} from 'floating-vue'

import DesktopHeader from './components/Global/DesktopHeader.vue'
import MobileHeader from './components/Global/MobileHeader.vue'
import Banner from './components/Global/Banner.vue'
import Modal from './components/Global/Modal.vue'
import VideoModal from './components/Global/VideoModal.vue'
import ResourceMenu from './components/Global/ResourceMenu.vue'
import Dropdown from './components/Global/Dropdown.vue'
import SelectCheckbox from './components/Global/SelectCheckbox.vue'
import FeaturedVillages from './components/Global/FeaturedVillages.vue'
import RegionCheckboxDropdown from './components/Global/RegionCheckboxDropdown.vue'

import HomeSearch from './components/HomeSearch/HomeSearch.vue'
import DownloadBooklet from './components/Forms/DownloadBooklet.vue'
import VueTinySlider from './components/VueTinySlider.vue'

import ListingFilters from './components/ListingPages/ListingFilters.vue'
import VillageList from './components/ListingPages/VillageList.vue'
import CareHomeList from './components/ListingPages/CareHomeList.vue'
import Events from './components/ListingPages/Events.vue'
import RegionDropdown from './components/ListingPages/RegionDropdown.vue'
import DistrictDropdown from './components/ListingPages/DistrictDropdown.vue'
import SuburbDropdown from './components/ListingPages/SuburbDropdown.vue'


import Pagination from './components/Pagination.vue'
import AddGoogleMap from './components/Google/AddGoogleMap.vue'
import VillageGoogleMap from './components/Google/VillageGoogleMap.vue'

import PropertyListEnquiry from './components/Forms/PropertyListEnquiry.vue'
import CareHomeEnquiry from './components/Forms/CareHomeEnquiry.vue'
import EnquirySuccessForm from './components/Forms/EnquirySuccessForm.vue'
import CareHomeEnquirySuccess from './components/Forms/CareHomeEnquirySuccess.vue'
import EventEnquiry from './components/Forms/EventEnquiry.vue'
import AgeConcernForm from './components/Forms/AgeConcernForm.vue'
import VillageInfoPackEnquiry from './components/Forms/VillageInfoPackEnquiry.vue'
import EmailEnquiry from './components/Forms/EmailEnquiry.vue'
import ShareForm from './components/Forms/ShareForm.vue'
import TypesOfHomeEnquiry from './components/Forms/TypesOfHomeEnquiry.vue'
import VillageContactForm from './components/Forms/VillageContactForm.vue'
import AttachmentEnquiry from './components/Forms/AttachmentEnquiry.vue'
import PropertyInfoForm from './components/Forms/PropertyInfoForm.vue'
import PropertyEmailEnquiry from './components/Forms/PropertyEmailEnquiry.vue'
import CareHomeEmailEnquiry from './components/Forms/CareHomeEmailEnquiry.vue'
import CareHomeTypeOfHomeEnquiry from './components/Forms/CareHomeTypeOfHomeEnquiry.vue'
import CareHomeFreeContactForm from './components/Forms/CareHomeFreeContactForm.vue'
import CareHomeContactForm from './components/Forms/CareHomeContactForm.vue'
import CompareForm from './components/Forms/CompareForm.vue'
import ArticleEnquiry from './components/Forms/ArticleEnquiry.vue'
import ArticleReportForm from './components/Forms/ArticleReportForm.vue'
import DeclutteringForm from './components/Forms/DeclutteringForm.vue'
import LearnMoreForm from './components/Forms/LearnMoreForm.vue'
import FacilityVillage from './components/Forms/FacilityVillage.vue'
import MediaKitForm from './components/Forms/MediaKitForm.vue'
import PropertyMarketForm from './components/Forms/PropertyMarketForm.vue'
import LearnMoreCareHomeForm from './components/Forms/LearnMoreCareHomeForm.vue'
import VillageContactMobileForm from './components/Forms/VillageContactMobileForm.vue'
import VillageEnquiryForm from './components/Forms/VillageEnquiryForm.vue'
import ResourceCentreForm from './components/Forms/ResourceCentreForm.vue'
import CareHomeReviewForm from './components/Forms/CareHomeReviewForm.vue'
import IndustryInsightsForm from "./components/Forms/IndustryInsightsForm.vue";
import ArticleFloorPlan from "./components/Forms/ArticleFloorPlan.vue";
import CareHomeRcEnquiry from "./components/Forms/CareHomeRcEnquiry.vue";

import LandingPage from './components/Pages/LandingPage.vue'
import ResourceCentre from './components/Pages/ResourceCentre.vue'
import Village from './components/Pages/Village.vue'
import Property from './components/Pages/Property.vue'
import Account from './components/Pages/Account.vue'
import SuggestedCareHome from './components/Pages/SuggestedCareHome.vue'
import CareHomeQuickResponse from './components/Pages/CareHomeQuickResponse.vue'

import CoolLightBox from './components/CoolLightBox/CoolLightBox'
import TypeOfHomes from './components/TypeOfHomes/TypeOfHomes.vue'
import AccordionItem from './components/Accordion/AccordionItem.vue'
import CareHomeHelpSlider from './components/CareHomeSlider/CareHomeHelpSlider.vue'
import CareHomeSlider from './components/CareHomeSlider/CareHomeSlider.vue'
import EdmSlider from './components/EdmSlider/EdmSlider.vue'
import LearnMoreSlider from './components/LearnMoreSlider/LearnMoreSlider.vue'
import SearchAutocomplete from './components/SearchAutocomplete.vue'

import GlobalStore from './store/globalStore'
import useFilterStore from './store/filterStore'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const RootApp = {
  components: {
    DesktopHeader,
    MobileHeader,
    Banner,
    Modal,
    VideoModal,
    Dropdown,
    RegionDropdown,
    DistrictDropdown,
    SuburbDropdown,
    HomeSearch,
    LandingPage,
    'v-tiny-slider': VueTinySlider,
    // Field,
    // Form,
    // ErrorMessage,
    VillageList,
    CareHomeList,
    Events,
    ListingFilters,
    Pagination,
    AddGoogleMap,
    Account,
    Village,
    'cool-light-box': CoolLightBox,
    // VillageGoogleMap,
    // TypeOfHomes,
    DownloadBooklet,
    PropertyListEnquiry,
    CareHomeEnquiry,
    EnquirySuccessForm,
    CareHomeEnquirySuccess,
    EventEnquiry,
    ResourceMenu,
    ResourceCentre,
    AgeConcernForm,
    VillageGoogleMap,
    VillageInfoPackEnquiry,
    EmailEnquiry,
    ShareForm,
    TypesOfHomeEnquiry,
    TypeOfHomes,
    VillageContactForm,
    AttachmentEnquiry,
    Property,
    PropertyInfoForm,
    PropertyEmailEnquiry,
    CareHomeEmailEnquiry,
    CareHomeTypeOfHomeEnquiry,
    CareHomeFreeContactForm,
    CareHomeContactForm,
    CompareForm,
    ArticleEnquiry,
    ArticleReportForm,
    DeclutteringForm,
    LearnMoreForm,
    AccordionItem,
    FacilityVillage,
    MediaKitForm,
    CareHomeSlider,
    CareHomeHelpSlider,
    SelectCheckbox,
    SuggestedCareHome,
    PropertyMarketForm,
    LearnMoreCareHomeForm,
    EdmSlider,
    VillageContactMobileForm,
    VillageEnquiryForm,
    FeaturedVillages,
    ResourceCentreForm,
    CareHomeQuickResponse,
    CareHomeReviewForm,
    LearnMoreSlider,
    SearchAutocomplete,
    RegionCheckboxDropdown,
    IndustryInsightsForm,
    ArticleFloorPlan,
    CareHomeRcEnquiry,
  },
  data() {
    return {
      isScreenXl: false,
      mySiteKeyVariable: null,
      districts: [],
      suburbList: [],
      controls: [
        '<i class=\'icon icon--arrow-left\'></i><span class="sr-only">Previous slide</span>',
        '<i class=\'icon icon--arrow-right\'></i><span class="sr-only">Next slide</span>',
      ],
      showSeoReadMore: false,
      districtList: [],
      shouldStick: true,
    };
  },
  // mixins: [addressFieldMixin],
  computed: {
    ...mapState(GlobalStore, ['showBanner', 'bannerHeight', 'isMobile', 'modal']),
  },
  methods: {
    ...mapActions(GlobalStore, ['setShowBanner', 'setBannerHeight', 'setIsMobile', 'setModal']),
  //   filterDistrictByRegion(id) {
  //     const vue = this;
  //     axios.get(`/filter-district/${id}`).then((response) => {
  //       vue.districts = response.data;
  //       document.getElementById('district').value = '';
  //     });
  //   },
  //
    filterRegionDistrict() {
      const type = document.getElementById('dropdownType').value;
      const filterStore = useFilterStore()

      const region = filterStore.region.url;
      const district = filterStore.district.url;
      let url = '';

      if (type === 'village') {
        url = `/retirement-villages`;
      } else {
        url = `/rest-homes`;
      }

      if (region) {
        url += `/${region}`
      }

      if (district) {
        url += `/${district}`
      }

      window.location.href = url;
    },

    toggleModal(modalName, showFooter) {
      this.setModal({name: modalName, showFooter: showFooter});

      if (modalName !== 'articleEnquiryModal' && modalName !== 'modalVideo') {
        history.pushState(null, null, `${window.location.href.split('?')[0]}?modal=${modalName}`);
      }

      // if (this.$refs.messageBox !== undefined) {
      //   this.$refs.messageBox.innerHTML = '';
      //   this.$refs.messageBox.style.display = 'none';
      // }
    },
    villageFilter(type) {
      const filterStore = useFilterStore()
      const region = filterStore.region.url;
      const district = filterStore.district.url;
      let urlString = `${window.location.protocol}//${window.location.hostname}/available-properties/`;

      if (type === 'village') {
        urlString = `${window.location.protocol}//${window.location.hostname}/retirement-villages/`;
      } else if (type === 'operator') {
        urlString = `${window.location.protocol}//${window.location.hostname}/operator/`;
      } else if (type === 'careHome') {
        urlString = `${window.location.protocol}//${window.location.hostname}/rest-homes/`;
      }

      if (district !== '') {
        urlString = `${urlString}${region}/${district}`;
      } else if (region !== '') {
        urlString = `${urlString}${region}`;
      }

      if (type === 'careHome') {
        const homeType = document.getElementById('homeTypes');
        if (homeType) {
          urlString = `${urlString}?level-care=${homeType.value}`;
        }
      } else if (type === 'village') {
        const homeType = document.getElementById('homeTypes');
        if (homeType) {
          urlString = `${urlString}?home-types=${homeType.value}`;
        }
      }
      window.location.href = urlString;
    },
    restHomeCareSubmit() {
    // get the form element
      const form = document.getElementById('rest-home-care-form');
      // get the form data
      const formData = new FormData(form);

      const filterStore = useFilterStore()
      const region = filterStore.region.url;
      const district = filterStore.district.url;
      let urlString = `${window.location.protocol}//${window.location.hostname}/rest-homes/`;

      if (district !== '') {
        urlString = `${urlString}${region}/${district}`;
      } else if (region !== '') {
        urlString = `${urlString}${region}`;
      }

      if (formData.get('level_of_care') !== '') {
        urlString = `${urlString}?level-care=${formData.get('level_of_care')}`;
      }

      if (formData.get('room_type') !== '') {
        urlString = `${urlString}&type-of-rooms=${formData.get('room_type')}`;
      }

      window.location.href = urlString;
    },

    dementiaCareSubmit() {
      // get the form element
      const form = document.getElementById('dementia-care-form');
      // get the form data
      const formData = new FormData(form);

      const filterStore = useFilterStore()
      const region = filterStore.region.url;
      const district = filterStore.district.url;
      let urlString = `${window.location.protocol}//${window.location.hostname}/rest-homes/`;

      if (district !== '') {
        urlString = `${urlString}${region}/${district}`;
      } else if (region !== '') {
        urlString = `${urlString}${region}`;
      }

      urlString = `${urlString}?level-care=3`;

      window.location.href = urlString;
    },

    triggerReadMore() {
      this.showSeoReadMore = true;
    },
    triggerReadLess() {
      this.showSeoReadMore = false;
    },
    showManagerNumber(e) {
      e.target.style.opacity = 0;
      e.target.parentElement.querySelector('span').style.opacity = '1';
      e.target.parentElement.querySelector('span').style.zIndex = '3';
    },
    favouriteSave() {
      if (document.getElementById('dontShowCheckbox').checked) {
        axios.post('/save-dont-show-favourite', {
          _token: document.head.querySelector('[name~=csrf-token][content]').content,
        });
      }

     this.hideModal();
    },
    hideModal() {
      this.setModal({name: '', title: ''});
      document.querySelector('body').classList.remove('modal-open', 'stop-scrolling');

      // remove the model from the url
      if (window.location.pathname === '/rest-homes-learn-more') {
        history.pushState(null, null, '/rest-homes-learn-more');
      } else {
        let currentUrl = window.location.href;
        currentUrl = currentUrl.replace('?modal=articlePropertyReportModal', '');
        history.pushState(null, null, `${currentUrl}`);
      }
    },
    featuredVillageClick(e) {
      const ele = e.target;
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
          'click': {
            'actionField': {'list': 'featured carousel'},
            'products': [
              {
                'id': ele.dataset.id,
                'name': ele.dataset.village,
                'brand': ele.dataset.operator,
                'category': 'village',
                'position': ele.dataset.position,
                'subscription': ele.dataset.subscription,
                'region': ele.dataset.region,
                'district': ele.dataset.district,
              }],
          },
        },
      });

      this.$nextTick(() => {
        let loc = '';
        if (ele.href === undefined) {
          loc = ele.dataset.href;
        } else {
          loc = ele.href;
        }
        document.location = loc;
      });
    },
    showInfoPackForm(villageId, villageName, action, e) {
        this.setModal({
          name: 'villageInfoPackModal',
          id: villageId,
          customField: action,
          title: villageName,
          descriptionPlaceholder: `Please send me an information pack for ${villageName}`,
        });

        localStorage.setItem('preSiteTitle', document.title);

        this.$nextTick(() => {
          const ele = e.target;
          const form = document.getElementById('village-enquiry-form');
          form.querySelector('#property_name').value = villageName;
          form.querySelector('#operator_name').value = ele.dataset.operatorName;
          form.querySelector('#operator_id').value = ele.dataset.operatorId;
          form.querySelector('#enquiry_type_full').value = ele.dataset.enquiryTypeFull;
          form.querySelector('#subscription').value = ele.dataset.subscription;
          form.querySelector('#enquiry_region').value = ele.dataset.enquiryRegion;
          form.querySelector('#enquiry_district').value = ele.dataset.enquiryDistrict;
        });
      },
  },
  mounted() {
    this.mySiteKeyVariable = document.getElementById('mySiteKeyVariable').value;

    if (window.innerWidth <= 991) {
      this.setIsMobile(true);
    }

    if (window.matchMedia('screen and (min-width: 1200px)').matches) {
      this.isScreenXl = true;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('lazyload');
        observer.unobserve(entry.target);
      }
    });

    const heroElement = document.querySelector('.homepage__hero');

    if (heroElement) {
      observer.observe(heroElement);
    }

    const hash = window.location.hash;

    if (hash) {
      const element = document.querySelector(hash);

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};

defineRule('required', required);
defineRule('email', email)
defineRule('numeric', numeric)
defineRule('phoneNumber', value => {
  const regex = new RegExp(/^([0-9 ]+)$/);

  return regex.test(value);
})


const fieldNames = {
  email: 'email address',
  password_confirmation: 'password confirm',
  first_name: 'first name',
  last_name: 'last name',
  your_name: 'your name',
  send_to: 'send to',
  current_password: 'current password',
  street_address: 'street address',
  phone_number: 'phone number',
  village_name: 'village name',
  care_home_name: 'care home name'
};

configure({
  generateMessage: ({ field, rule }) => {
    const fieldName = fieldNames[field] || field;
    const messages = {
      required: `The ${fieldName} is required`,
      email: `The ${fieldName} must be a valid email`,
    };
    return messages[rule.name] || `${fieldName} is invalid`;
  },
});

const app = createApp(RootApp)
app.use(pinia)
app.use(Sticky)
app.use(VueClickAway)
app.use(VueScrollTo)
app.directive('tooltip', vTooltip)
app.component('VTooltip', Tooltip)
app.use(VueGoogleMaps, {
  load: {
    'libraries': 'places',
    key: process.env.MIX_GOOGLE_MAP_KEY,
  },
})
const csrf = document.getElementsByTagName('META');
axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf['csrf-token'].content;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
app.mount('#app')
